import { render } from "./CreateHoliday.vue?vue&type=template&id=344c8955"
import script from "./CreateHoliday.vue?vue&type=script&lang=js"
export * from "./CreateHoliday.vue?vue&type=script&lang=js"

import "./CreateHoliday.vue?vue&type=style&index=0&id=344c8955&lang=css"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__